import {
  DeleteOutlined,
  LoadingOutlined,
  PlusOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import {
  Button,
  Card,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  Result,
  Row,
  Select,
  Spin,
  Upload,
} from "antd";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import InventoryMasterService from "../../../Services/Inventory/InventoryMasterService";
import { useClient } from "../../../Context/ClientContext";
import { BankAccountType_New } from "../../../Services/Vendor/VendorRegistrationService";
interface IFifStepReg {
  index: number;
  form: any;
}
const FifthStepReg = ({ index, form }: IFifStepReg) => {
  const { vendorClientId } = useParams();
  const [masterData, setMasterData] = React.useState<any>();
  const [loading, setLoading] = React.useState<boolean>(false);
  const [hideContent, setHideContent] = React.useState<any>({
    iSOCertified: false,
    balanceSheet: false,
    FSSAILicense: false,
    turnOverDetails: false,
    IEC: false,
    memorandumOfAssociation: false,
    certificateNumber: false,
    clientageDetail: false,
    equipmentList: false,
    machineryList: false,
    GSTCertificate: false,
    PAN: false,
    TAN: false,
    CIN: false,
    udhyam: false,
    ISI: false,
    factory: false,
    bankDetails: false,
    bankSolvency: false,
    supplies: false,
    listOfDirector: false,
    productDetail: false,
  });

  const handleCheckboxChange = (key: any) => (e: any) => {
    setHideContent((prevState: any) => ({
      ...prevState,
      [key]: e.target.checked,
    }));
  };

  React.useEffect(() => {
    getMasterDetails();
  }, []);

  const getMasterDetails = async () => {
    setLoading(true);
    let res = await InventoryMasterService?.getMasterDetails(
      vendorClientId,
      "",
      "",
      "",
      true
    );

    if (res?.result) {
      setMasterData(res?.result?.map((d: any) => ({ docType: d?.docType })));
      setLoading(false);
    } else {
      setMasterData([]);
      setLoading(false);
    }
  };

  console.log("data", masterData);

  return (
    <>
      <div
        style={{
          maxWidth: "800px",
          margin: "0 auto",
          maxHeight: "730px",
          overflowY: "scroll",
        }}
      >
        {/* <Form.Item label="Organization Name">
            <Input/>
          </Form.Item> */}

        <Card
          size="small"
          title="Document Checklist"
          style={{ width: "100%" }}
          type="inner"
        >
          <Spin indicator={<LoadingOutlined />} spinning={loading}>
            {/* {masterData?.some((d: any) => d.docType === 2) && (
              <>
                <Row gutter={10}>
                  <Col style={{ padding: "14px 7px" }}>
                    <Checkbox onChange={handleCheckboxChange("PAN")} />
                  </Col>
                  <Col style={{ padding: "14px 7px" }}>PAN</Col>
                  {hideContent?.PAN && (
                    <>
                      <Col style={{ marginLeft: "auto" }}>
                        <Form.Item
                          className="m-0"
                          name={[index, "PANDoc"]}
                          valuePropName="fileList"
                          getValueFromEvent={(e) => {
                            return e.fileList;
                          }}
                        >
                          <Upload
                            showUploadList={false}
                            accept=".doc,.docx,.pdf,.jpg,.jpeg,.png,.txt,.csv,.gif,.xls,.xlsx"
                            beforeUpload={(file) => {
                              if (file.size > 5242880) {
                                return Upload.LIST_IGNORE;
                              } else return false;
                            }}
                          >
                            <Button
                              style={{ marginTop: "10px", color: "#058BC9" }}
                              icon={<UploadOutlined />}
                            >
                              Upload
                            </Button>
                          </Upload>
                        </Form.Item>
                      </Col>
                    </>
                  )}
                </Row>

                {hideContent?.PAN && (
                  <>
                    <Row>
                      <Col span={7}>
                        <Form.Item
                          className="m-0"
                          label="Number"
                          name={[index, "PANNumber"]}
                        >
                          <Input />
                        </Form.Item>
                      </Col>
                    </Row>
                  </>
                )}
              </>
            )} */}

            {masterData?.some((d: any) => d.docType === 3) && (
              <>
                <Row gutter={10}>
                  <Col style={{ padding: "14px 7px" }}>
                    <Checkbox onChange={handleCheckboxChange("TAN")} />
                  </Col>
                  <Col style={{ padding: "14px 7px" }}>TAN Certificate</Col>
                  {hideContent?.TAN && (
                    <>
                      <Col
                        style={{
                          marginLeft: "auto",
                          textAlign: "end",
                          display: "flex",
                          justifyContent: "end",
                        }}
                      >
                        <Form.Item
                          className="m-0"
                          name={[index, "TANDocument"]}
                          valuePropName="fileList"
                          getValueFromEvent={(e) => {
                            return e.fileList;
                          }}
                        >
                          <Upload
                            accept=".doc,.docx,.pdf,.jpg,.jpeg,.png,.txt,.csv,.gif,.xls,.xlsx"
                            beforeUpload={(file: any) => {
                              if (file.size > 5242880) {
                                return Upload.LIST_IGNORE;
                              }

                              const reader = new FileReader();
                              reader.readAsDataURL(file);
                              reader.onload = () => {
                                file.base64 = reader.result;
                                const formFieldValue =
                                  form
                                    .useFormInstance()
                                    ?.getFieldValue([
                                      index,
                                      "equipmentListDocument",
                                    ]) || [];
                                form
                                  .useFormInstance()
                                  ?.setFieldsValue([
                                    index,
                                    "equipmentListDocument",
                                    [...formFieldValue, file],
                                  ]);
                              };
                              return false; // Prevent auto-upload
                            }}
                          >
                            <Button
                              style={{ marginTop: "10px", color: "#058BC9" }}
                              icon={<UploadOutlined />}
                            >
                              Upload
                            </Button>
                          </Upload>
                        </Form.Item>
                      </Col>
                    </>
                  )}
                </Row>

                {hideContent?.TAN && (
                  <>
                    <Row justify={"space-between"}>
                      <Col span={7}>
                        <Form.Item
                          className="m-0"
                          label="Number"
                          name={[index, "TANNumber"]}
                        >
                          <Input />
                        </Form.Item>
                      </Col>
                    </Row>
                  </>
                )}
              </>
            )}

            {/* {masterData?.some((d: any) => d.docType === 5) && (
              <>
                <Row gutter={10}>
                  <Col style={{ padding: "14px 7px" }}>
                    <Checkbox onChange={handleCheckboxChange("udhyam")} />
                  </Col>
                  <Col style={{ padding: "14px 7px" }}> Udhyam </Col>
                  {hideContent?.udhyam && (
                    <>
                      <Col style={{ marginLeft: "auto" }}>
                        <Form.Item
                          className="m-0"
                          name={[index, "udhyamDocument"]}
                          valuePropName="fileList"
                          getValueFromEvent={(e) => {
                            return e.fileList;
                          }}
                        >
                          <Upload
                            accept=".doc,.docx,.pdf,.jpg,.jpeg,.png,.txt,.csv,.gif,.xls,.xlsx"
                            beforeUpload={(file) => {
                              if (file.size > 5242880) {
                                return Upload.LIST_IGNORE;
                              } else return false;
                            }}
                            showUploadList={false}
                          >
                            <Button
                              style={{ marginTop: "10px", color: "#058BC9" }}
                              icon={<UploadOutlined />}
                            >
                              Upload
                            </Button>
                          </Upload>
                        </Form.Item>
                      </Col>
                    </>
                  )}
                </Row>

                {hideContent?.udhyam && (
                  <>
                    <Row justify={"space-between"}>
                      <Col span={7}>
                        <Form.Item
                          className="m-0"
                          label="Number"
                          name={[index, "udhyamNumber"]}
                        >
                          <Input />
                        </Form.Item>
                      </Col>
                    </Row>
                  </>
                )}
              </>
            )} */}

            {masterData?.some((d: any) => d.docType === 4) && (
              <>
                <Row gutter={10}>
                  <Col style={{ padding: "14px 7px" }}>
                    <Checkbox onChange={handleCheckboxChange("CIN")} />
                  </Col>
                  <Col style={{ padding: "14px 7px" }}>CIN Certificate</Col>
                  {hideContent?.CIN && (
                    <>
                      <Col
                        style={{
                          marginLeft: "auto",
                          textAlign: "end",
                          display: "flex",
                          justifyContent: "end",
                        }}
                      >
                        <Form.Item
                          className="m-0"
                          name={[index, "CINDocument"]}
                          valuePropName="fileList"
                          getValueFromEvent={(e) => {
                            return e.fileList;
                          }}
                        >
                          <Upload
                            accept=".doc,.docx,.pdf,.jpg,.jpeg,.png,.txt,.csv,.gif,.xls,.xlsx"
                            beforeUpload={(file: any) => {
                              if (file.size > 5242880) {
                                return Upload.LIST_IGNORE;
                              }

                              const reader = new FileReader();
                              reader.readAsDataURL(file);
                              reader.onload = () => {
                                file.base64 = reader.result;
                                const formFieldValue =
                                  form
                                    .useFormInstance()
                                    ?.getFieldValue([
                                      index,
                                      "equipmentListDocument",
                                    ]) || [];
                                form
                                  .useFormInstance()
                                  ?.setFieldsValue([
                                    index,
                                    "equipmentListDocument",
                                    [...formFieldValue, file],
                                  ]);
                              };
                              return false; // Prevent auto-upload
                            }}
                          >
                            <Button
                              style={{ marginTop: "10px", color: "#058BC9" }}
                              icon={<UploadOutlined />}
                            >
                              Upload
                            </Button>
                          </Upload>
                        </Form.Item>
                      </Col>
                    </>
                  )}
                </Row>

                {hideContent?.CIN && (
                  <>
                    <Row>
                      <Col span={7}>
                        <Form.Item
                          className="m-0"
                          label="Number"
                          name={[index, "CINNumber"]}
                        >
                          <Input />
                        </Form.Item>
                      </Col>
                    </Row>
                  </>
                )}
              </>
            )}

            {/* {masterData?.some((d: any) => d?.docType === 1) && (
              <>
                <Row gutter={10}>
                  <Col style={{ padding: "14px 7px" }}>
                    <Checkbox
                      onChange={handleCheckboxChange("GSTCertificate")}
                    />
                  </Col>
                  <Col style={{ padding: "14px 7px" }}>
                    GST Certificate Certificate
                  </Col>
                  {hideContent?.GSTCertificate && (
                    <>
                      <Col style={{ marginLeft: "auto" }}>
                        <Form.Item
                          className="m-0"
                          name={[index, "GSTDocument"]}
                          valuePropName="fileList"
                          getValueFromEvent={(e) => {
                            return e.fileList;
                          }}
                        >
                          <Upload
                            accept=".doc,.docx,.pdf,.jpg,.jpeg,.png,.txt,.csv,.gif,.xls,.xlsx"
                            beforeUpload={(file) => {
                              if (file.size > 5242880) {
                                return Upload.LIST_IGNORE;
                              } else return false;
                            }}
                            showUploadList={false}
                          >
                            <Button
                              style={{ marginTop: "10px", color: "#058BC9" }}
                              icon={<UploadOutlined />}
                            >
                              Upload
                            </Button>
                          </Upload>
                        </Form.Item>
                      </Col>
                    </>
                  )}
                </Row>

                {hideContent?.GSTCertificate && (
                  <>
                    <Row>
                      <Col span={7}>
                        <Form.Item
                          className="m-0"
                          label="GST Number"
                          name={[index, "GSTNumber"]}
                        >
                          <Input />
                        </Form.Item>
                      </Col>
                    </Row>
                  </>
                )}
              </>
            )} */}

            {masterData?.some((d: any) => d.docType === 7) && (
              <>
                <Row gutter={10}>
                  <Col style={{ padding: "14px 7px" }}>
                    <Checkbox onChange={handleCheckboxChange("iSOCertified")} />
                  </Col>
                  <Col style={{ padding: "14px 7px" }}>
                    ISO Quality Certificate
                  </Col>
                  {hideContent?.iSOCertified && (
                    <>
                      <Col
                        style={{
                          marginLeft: "auto",
                          textAlign: "end",
                          display: "flex",
                          justifyContent: "end",
                        }}
                      >
                        <Form.Item
                          className="m-0"
                          name={[index, "ISODocument"]}
                          valuePropName="fileList"
                          getValueFromEvent={(e) => {
                            return e.fileList;
                          }}
                        >
                          <Upload
                            accept=".doc,.docx,.pdf,.jpg,.jpeg,.png,.txt,.csv,.gif,.xls,.xlsx"
                            beforeUpload={(file: any) => {
                              if (file.size > 5242880) {
                                return Upload.LIST_IGNORE;
                              }

                              const reader = new FileReader();
                              reader.readAsDataURL(file);
                              reader.onload = () => {
                                file.base64 = reader.result;
                                const formFieldValue =
                                  form
                                    .useFormInstance()
                                    ?.getFieldValue([
                                      index,
                                      "equipmentListDocument",
                                    ]) || [];
                                form
                                  .useFormInstance()
                                  ?.setFieldsValue([
                                    index,
                                    "equipmentListDocument",
                                    [...formFieldValue, file],
                                  ]);
                              };
                              return false; // Prevent auto-upload
                            }}
                          >
                            <Button
                              style={{ marginTop: "10px", color: "#058BC9" }}
                              icon={<UploadOutlined />}
                            >
                              Upload
                            </Button>
                          </Upload>
                        </Form.Item>
                      </Col>
                    </>
                  )}
                </Row>

                {hideContent?.iSOCertified && (
                  <>
                    <Row gutter={10}>
                      <Col span={7}>
                        <Form.Item
                          className="m-0"
                          label="ISO Number"
                          name={[index, "ISONumber"]}
                        >
                          <Input />
                        </Form.Item>
                      </Col>

                      <Col span={7}>
                        <Form.Item
                          className="m-0"
                          label="Expiry Date"
                          name={[index, "ISIExpiryDate"]}
                        >
                          <DatePicker style={{ width: "100%" }} />
                        </Form.Item>
                      </Col>
                    </Row>
                  </>
                )}
              </>
            )}

            {masterData?.some((d: any) => d.docType === 12) && (
              <>
                <Row gutter={10}>
                  <Col style={{ padding: "14px 7px" }}>
                    <Checkbox onChange={handleCheckboxChange("factory")} />
                  </Col>
                  <Col style={{ padding: "14px 7px" }}>
                    Factory Registration Certificate
                  </Col>

                  {hideContent?.factory && (
                    <Col
                      style={{
                        marginLeft: "auto",
                        textAlign: "end",
                        display: "flex",
                        justifyContent: "end",
                      }}
                    >
                      <Form.Item
                        className="m-0"
                        name={[index, "factoryRegistrationDocument"]}
                        valuePropName="fileList"
                        getValueFromEvent={(e) => {
                          return e.fileList;
                        }}
                      >
                        <Upload
                          accept=".doc,.docx,.pdf,.jpg,.jpeg,.png,.txt,.csv,.gif,.xls,.xlsx"
                          beforeUpload={(file: any) => {
                            if (file.size > 5242880) {
                              return Upload.LIST_IGNORE;
                            }

                            const reader = new FileReader();
                            reader.readAsDataURL(file);
                            reader.onload = () => {
                              file.base64 = reader.result;
                              const formFieldValue =
                                form
                                  .useFormInstance()
                                  ?.getFieldValue([
                                    index,
                                    "equipmentListDocument",
                                  ]) || [];
                              form
                                .useFormInstance()
                                ?.setFieldsValue([
                                  index,
                                  "equipmentListDocument",
                                  [...formFieldValue, file],
                                ]);
                            };
                            return false; // Prevent auto-upload
                          }}
                        >
                          <Button
                            style={{ marginTop: "10px", color: "#058BC9" }}
                            icon={<UploadOutlined />}
                          >
                            Upload
                          </Button>
                        </Upload>
                      </Form.Item>
                    </Col>
                  )}
                </Row>
              </>
            )}

            {masterData?.some((d: any) => d.docType === 8) && (
              <>
                <Row gutter={10}>
                  <Col style={{ padding: "14px 7px" }}>
                    <Checkbox onChange={handleCheckboxChange("ISI")} />
                  </Col>
                  <Col style={{ padding: "14px 7px" }}>ISI Certificate</Col>
                  {hideContent?.ISI && (
                    <>
                      <Col
                        style={{
                          marginLeft: "auto",
                          textAlign: "end",
                          display: "flex",
                          justifyContent: "end",
                        }}
                      >
                        <Form.Item
                          className="m-0"
                          name={[index, "ISIDocument"]}
                          valuePropName="fileList"
                          getValueFromEvent={(e) => {
                            return e.fileList;
                          }}
                        >
                          <Upload
                            accept=".doc,.docx,.pdf,.jpg,.jpeg,.png,.txt,.csv,.gif,.xls,.xlsx"
                            beforeUpload={(file: any) => {
                              if (file.size > 5242880) {
                                return Upload.LIST_IGNORE;
                              }

                              const reader = new FileReader();
                              reader.readAsDataURL(file);
                              reader.onload = () => {
                                file.base64 = reader.result;
                                const formFieldValue =
                                  form
                                    .useFormInstance()
                                    ?.getFieldValue([
                                      index,
                                      "equipmentListDocument",
                                    ]) || [];
                                form
                                  .useFormInstance()
                                  ?.setFieldsValue([
                                    index,
                                    "equipmentListDocument",
                                    [...formFieldValue, file],
                                  ]);
                              };
                              return false; // Prevent auto-upload
                            }}
                          >
                            <Button
                              style={{ marginTop: "10px", color: "#058BC9" }}
                              icon={<UploadOutlined />}
                            >
                              Upload
                            </Button>
                          </Upload>
                        </Form.Item>
                      </Col>
                    </>
                  )}
                </Row>

                {hideContent?.ISI && (
                  <>
                    <Row gutter={10}>
                      <Col span={7}>
                        <Form.Item
                          className="m-0"
                          label="ISINumber"
                          name={[index, "ISINumber"]}
                        >
                          <Input />
                        </Form.Item>
                      </Col>
                      <Col span={8}>
                        <Form.Item
                          label="Expiry Date"
                          name={[index, "ISIExpiryDate"]}
                        >
                          <DatePicker style={{ width: "100%" }} />
                        </Form.Item>
                      </Col>
                    </Row>
                  </>
                )}
              </>
            )}

            {masterData?.some((d: any) => d.docType === 9) && (
              <>
                <Row gutter={10}>
                  <Col style={{ padding: "14px 7px" }}>
                    <Checkbox onChange={handleCheckboxChange("balanceSheet")} />
                  </Col>
                  <Col style={{ padding: "14px 7px" }}>
                    Audited Balance Sheet
                  </Col>
                  {hideContent?.balanceSheet && (
                    <>
                      <Col
                        style={{
                          marginLeft: "auto",
                          textAlign: "end",
                          display: "flex",
                          justifyContent: "end",
                        }}
                      >
                        <Form.Item
                          className="m-0"
                          name={[index, "balanceSheetDocument"]}
                          valuePropName="fileList"
                          getValueFromEvent={(e) => {
                            return e.fileList;
                          }}
                        >
                          <Upload
                            accept=".doc,.docx,.pdf,.jpg,.jpeg,.png,.txt,.csv,.gif,.xls,.xlsx"
                            beforeUpload={(file: any) => {
                              if (file.size > 5242880) {
                                return Upload.LIST_IGNORE;
                              }

                              const reader = new FileReader();
                              reader.readAsDataURL(file);
                              reader.onload = () => {
                                file.base64 = reader.result;
                                const formFieldValue =
                                  form
                                    .useFormInstance()
                                    ?.getFieldValue([
                                      index,
                                      "equipmentListDocument",
                                    ]) || [];
                                form
                                  .useFormInstance()
                                  ?.setFieldsValue([
                                    index,
                                    "equipmentListDocument",
                                    [...formFieldValue, file],
                                  ]);
                              };
                              return false;
                            }}
                          >
                            <Button
                              style={{ marginTop: "10px", color: "#058BC9" }}
                              icon={<UploadOutlined />}
                            >
                              Upload
                            </Button>
                          </Upload>
                        </Form.Item>
                      </Col>
                    </>
                  )}
                </Row>
              </>
            )}

            {masterData?.some((d: any) => d.docType === 18) && (
              <>
                <Row gutter={10}>
                  <Col style={{ padding: "14px 7px" }}>
                    <Checkbox
                      onChange={handleCheckboxChange("turnOverDetails")}
                    />
                  </Col>
                  <Col style={{ padding: "14px 7px" }}>Turnover Details</Col>
                  {hideContent?.turnOverDetails && (
                    <>
                      <Col
                        style={{
                          marginLeft: "auto",
                          textAlign: "end",
                          display: "flex",
                          justifyContent: "end",
                        }}
                      >
                        <Form.Item
                          className="m-0"
                          name={[index, "turnOverDocument"]}
                          valuePropName="fileList"
                          getValueFromEvent={(e) => {
                            return e.fileList;
                          }}
                        >
                          <Upload
                            accept=".doc,.docx,.pdf,.jpg,.jpeg,.png,.txt,.csv,.gif,.xls,.xlsx"
                            beforeUpload={(file: any) => {
                              if (file.size > 5242880) {
                                return Upload.LIST_IGNORE;
                              }

                              const reader = new FileReader();
                              reader.readAsDataURL(file);
                              reader.onload = () => {
                                file.base64 = reader.result;
                                const formFieldValue =
                                  form
                                    .useFormInstance()
                                    ?.getFieldValue([
                                      index,
                                      "equipmentListDocument",
                                    ]) || [];
                                form
                                  .useFormInstance()
                                  ?.setFieldsValue([
                                    index,
                                    "equipmentListDocument",
                                    [...formFieldValue, file],
                                  ]);
                              };
                              return false;
                            }}
                          >
                            <Button
                              style={{ marginTop: "10px", color: "#058BC9" }}
                              icon={<UploadOutlined />}
                            >
                              Upload
                            </Button>
                          </Upload>
                        </Form.Item>
                      </Col>
                    </>
                  )}
                </Row>
              </>
            )}

            {hideContent?.turnOverDetails && (
              <>
                <Row justify={"space-between"}>
                  <Col span={7}>
                    <Form.Item
                      className="m-0"
                      label="Last 1 Year"
                      name={[index, "last1Year"]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col span={7}>
                    <Form.Item
                      className="m-0"
                      label="Last 2 Year"
                      name={[index, "last2Year"]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col span={7}>
                    <Form.Item
                      className="m-0"
                      label="Last 3 Year"
                      name={[index, "last3Year"]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                </Row>
              </>
            )}
            {masterData?.some((d: any) => d.docType === 6) && (
              <>
                <Row gutter={10}>
                  <Col style={{ padding: "14px 7px" }}>
                    <Checkbox onChange={handleCheckboxChange("IEC")} />
                  </Col>
                  <Col style={{ padding: "14px 7px" }}>
                    Import Export Certificate (IEC)
                  </Col>
                  {hideContent?.IEC && (
                    <>
                      <Col
                        style={{
                          marginLeft: "auto",
                          textAlign: "end",
                          display: "flex",
                          justifyContent: "end",
                        }}
                      >
                        <Form.Item
                          className="m-0"
                          name={[index, "IECDocument"]}
                          valuePropName="fileList"
                          getValueFromEvent={(e) => {
                            return e.fileList;
                          }}
                        >
                          <Upload
                            accept=".doc,.docx,.pdf,.jpg,.jpeg,.png,.txt,.csv,.gif,.xls,.xlsx"
                            beforeUpload={(file: any) => {
                              if (file.size > 5242880) {
                                return Upload.LIST_IGNORE;
                              }

                              const reader = new FileReader();
                              reader.readAsDataURL(file);
                              reader.onload = () => {
                                file.base64 = reader.result;
                                const formFieldValue =
                                  form
                                    .useFormInstance()
                                    ?.getFieldValue([
                                      index,
                                      "equipmentListDocument",
                                    ]) || [];
                                form
                                  .useFormInstance()
                                  ?.setFieldsValue([
                                    index,
                                    "equipmentListDocument",
                                    [...formFieldValue, file],
                                  ]);
                              };
                              return false;
                            }}
                          >
                            <Button
                              style={{ marginTop: "10px", color: "#058BC9" }}
                              icon={<UploadOutlined />}
                            >
                              Upload
                            </Button>
                          </Upload>
                        </Form.Item>
                      </Col>
                    </>
                  )}
                </Row>
              </>
            )}
            {masterData?.some((d: any) => d.docType === 10) && (
              <>
                {hideContent?.IEC && (
                  <>
                    <Row>
                      <Col span={7}>
                        <Form.Item
                          className="m-0"
                          label="IEC Number"
                          name={[index, "IECNumber"]}
                        >
                          <Input />
                        </Form.Item>
                      </Col>
                    </Row>
                  </>
                )}
                <Row gutter={10}>
                  <Col style={{ padding: "14px 7px" }}>
                    <Checkbox
                      onChange={handleCheckboxChange("memorandumOfAssociation")}
                    />
                  </Col>
                  <Col style={{ padding: "14px 7px" }}>
                    Memorandum of Association (MOU)
                  </Col>
                  {hideContent?.memorandumOfAssociation && (
                    <>
                      <Col
                        style={{
                          marginLeft: "auto",
                          textAlign: "end",
                          display: "flex",
                          justifyContent: "end",
                        }}
                      >
                        <Form.Item
                          className="m-0"
                          name={[index, "MOUDocument"]}
                          valuePropName="fileList"
                          getValueFromEvent={(e) => {
                            return e.fileList;
                          }}
                        >
                          <Upload
                            accept=".doc,.docx,.pdf,.jpg,.jpeg,.png,.txt,.csv,.gif,.xls,.xlsx"
                            beforeUpload={(file: any) => {
                              if (file.size > 5242880) {
                                return Upload.LIST_IGNORE;
                              }

                              const reader = new FileReader();
                              reader.readAsDataURL(file);
                              reader.onload = () => {
                                file.base64 = reader.result;
                                const formFieldValue =
                                  form
                                    .useFormInstance()
                                    ?.getFieldValue([
                                      index,
                                      "equipmentListDocument",
                                    ]) || [];
                                form
                                  .useFormInstance()
                                  ?.setFieldsValue([
                                    index,
                                    "equipmentListDocument",
                                    [...formFieldValue, file],
                                  ]);
                              };
                              return false;
                            }}
                          >
                            <Button
                              style={{ marginTop: "10px", color: "#058BC9" }}
                              icon={<UploadOutlined />}
                            >
                              Upload
                            </Button>
                          </Upload>
                        </Form.Item>
                      </Col>
                    </>
                  )}
                </Row>
              </>
            )}

            {masterData?.some((d: any) => d.docType === 11) && (
              <>
                <Row gutter={10}>
                  <Col style={{ padding: "14px 7px" }}>
                    <Checkbox
                      onChange={handleCheckboxChange("certificateNumber")}
                    />
                  </Col>
                  <Col style={{ padding: "14px 7px" }}>
                    Incorporation Certificate Number
                  </Col>
                  {hideContent?.certificateNumber && (
                    <>
                      <Col
                        style={{
                          marginLeft: "auto",
                          textAlign: "end",
                          display: "flex",
                          justifyContent: "end",
                        }}
                      >
                        <Form.Item
                          valuePropName="fileList"
                          getValueFromEvent={(e) => {
                            return e.fileList;
                          }}
                          className="m-0"
                          name={[index, "incorporationDocument"]}
                        >
                          <Upload
                            accept=".doc,.docx,.pdf,.jpg,.jpeg,.png,.txt,.csv,.gif,.xls,.xlsx"
                            beforeUpload={(file: any) => {
                              if (file.size > 5242880) {
                                return Upload.LIST_IGNORE;
                              }

                              const reader = new FileReader();
                              reader.readAsDataURL(file);
                              reader.onload = () => {
                                file.base64 = reader.result;
                                const formFieldValue =
                                  form
                                    .useFormInstance()
                                    ?.getFieldValue([
                                      index,
                                      "equipmentListDocument",
                                    ]) || [];
                                form
                                  .useFormInstance()
                                  ?.setFieldsValue([
                                    index,
                                    "equipmentListDocument",
                                    [...formFieldValue, file],
                                  ]);
                              };
                              return false;
                            }}
                          >
                            <Button
                              style={{ marginTop: "10px", color: "#058BC9" }}
                              icon={<UploadOutlined />}
                            >
                              Upload
                            </Button>
                          </Upload>
                        </Form.Item>
                      </Col>
                    </>
                  )}
                </Row>
              </>
            )}

            {masterData?.some((d: any) => d.docType === 15) && (
              <>
                <Row gutter={10}>
                  <Col style={{ padding: "14px 7px" }}>
                    <Checkbox
                      onChange={handleCheckboxChange("machineryList")}
                    />
                  </Col>
                  <Col style={{ padding: "14px 7px" }}>
                    Plant & Machinery List
                  </Col>

                  {hideContent?.machineryList && (
                    <Col
                      style={{
                        marginLeft: "auto",
                        textAlign: "end",
                        display: "flex",
                        justifyContent: "end",
                      }}
                    >
                      <Form.Item
                        className="m-0"
                        name={[index, "machineryListDocument"]}
                        valuePropName="fileList"
                        getValueFromEvent={(e) => {
                          return e.fileList;
                        }}
                      >
                        <Upload
                          accept=".doc,.docx,.pdf,.jpg,.jpeg,.png,.txt,.csv,.gif,.xls,.xlsx"
                          beforeUpload={(file: any) => {
                            if (file.size > 5242880) {
                              return Upload.LIST_IGNORE;
                            }

                            const reader = new FileReader();
                            reader.readAsDataURL(file);
                            reader.onload = () => {
                              file.base64 = reader.result;
                              const formFieldValue =
                                form
                                  .useFormInstance()
                                  ?.getFieldValue([
                                    index,
                                    "equipmentListDocument",
                                  ]) || [];
                              form
                                .useFormInstance()
                                ?.setFieldsValue([
                                  index,
                                  "equipmentListDocument",
                                  [...formFieldValue, file],
                                ]);
                            };
                            return false;
                          }}
                        >
                          <Button
                            style={{ marginTop: "10px", color: "#058BC9" }}
                            icon={<UploadOutlined />}
                          >
                            Upload
                          </Button>
                        </Upload>
                      </Form.Item>
                    </Col>
                  )}
                </Row>
              </>
            )}

            {hideContent?.machineryList && (
              <>
                <Row>
                  <Col span={7}>
                    <Form.Item
                      className="m-0"
                      label="Name"
                      name={[index, "machineryListNumber"]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                </Row>
              </>
            )}

            {masterData?.some((d: any) => d.docType === 16) && (
              <>
                <Row gutter={10}>
                  <Col style={{ padding: "14px 7px" }}>
                    <Checkbox
                      onChange={handleCheckboxChange("equipmentList")}
                    />
                  </Col>
                  <Col style={{ padding: "14px 7px" }}>
                    Testing Equipments List with Calibration Status
                  </Col>
                  {hideContent?.equipmentList && (
                    <>
                      <Col
                        style={{
                          marginLeft: "auto",
                          textAlign: "end",
                          display: "flex",
                          justifyContent: "end",
                        }}
                      >
                        <Form.Item
                          className="m-0"
                          name={[index, "equipmentListDocument"]}
                          valuePropName="fileList"
                          getValueFromEvent={(e) => {
                            return e.fileList;
                          }}
                        >
                          <Upload
                            accept=".doc,.docx,.pdf,.jpg,.jpeg,.png,.txt,.csv,.gif,.xls,.xlsx"
                            beforeUpload={(file: any) => {
                              if (file.size > 5242880) {
                                return Upload.LIST_IGNORE;
                              }

                              const reader = new FileReader();
                              reader.readAsDataURL(file);
                              reader.onload = () => {
                                file.base64 = reader.result;
                                const formFieldValue =
                                  form
                                    .useFormInstance()
                                    ?.getFieldValue([
                                      index,
                                      "equipmentListDocument",
                                    ]) || [];
                                form
                                  .useFormInstance()
                                  ?.setFieldsValue([
                                    index,
                                    "equipmentListDocument",
                                    [...formFieldValue, file],
                                  ]);
                              };
                              return false;
                            }}
                          >
                            <Button
                              style={{
                                marginTop: "10px",
                                color: "#058BC9",
                              }}
                              icon={<UploadOutlined />}
                            >
                              Upload
                            </Button>
                          </Upload>
                        </Form.Item>
                      </Col>
                    </>
                  )}
                </Row>
              </>
            )}

            {hideContent?.equipmentList && (
              <>
                <Row gutter={10}>
                  <Col span={7}>
                    <Form.Item
                      className="m-0"
                      label="Name"
                      name={[index, "equipmentNumber"]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col span={7}>
                    <Form.Item
                      className="m-0"
                      label="Calibration Status"
                      name={[index, "equipmentExpiryDate"]}
                    >
                      <DatePicker style={{ width: "100%" }} />
                    </Form.Item>
                  </Col>
                </Row>
              </>
            )}
            {masterData?.some((d: any) => d.docType === 13) && (
              <>
                <Row gutter={10}>
                  <Col style={{ padding: "14px 7px" }}>
                    <Checkbox onChange={handleCheckboxChange("bankSolvency")} />
                  </Col>
                  <Col style={{ padding: "14px 7px" }}>Bank Solvency Form</Col>
                  {hideContent?.bankSolvency && (
                    <>
                      <Col
                        style={{
                          marginLeft: "auto",
                          textAlign: "end",
                          display: "flex",
                          justifyContent: "end",
                        }}
                      >
                        <Form.Item
                          className="m-0"
                          name={[index, "bankSolvencyDocument"]}
                          valuePropName="fileList"
                          getValueFromEvent={(e) => {
                            return e.fileList;
                          }}
                        >
                          <Upload
                            accept=".doc,.docx,.pdf,.jpg,.jpeg,.png,.txt,.csv,.gif,.xls,.xlsx"
                            beforeUpload={(file: any) => {
                              if (file.size > 5242880) {
                                return Upload.LIST_IGNORE;
                              }

                              const reader = new FileReader();
                              reader.readAsDataURL(file);
                              reader.onload = () => {
                                file.base64 = reader.result;
                                const formFieldValue =
                                  form
                                    .useFormInstance()
                                    ?.getFieldValue([
                                      index,
                                      "equipmentListDocument",
                                    ]) || [];
                                form
                                  .useFormInstance()
                                  ?.setFieldsValue([
                                    index,
                                    "equipmentListDocument",
                                    [...formFieldValue, file],
                                  ]);
                              };
                              return false;
                            }}
                          >
                            <Button
                              style={{ marginTop: "10px", color: "#058BC9" }}
                              icon={<UploadOutlined />}
                            >
                              Upload
                            </Button>
                          </Upload>
                        </Form.Item>
                      </Col>
                    </>
                  )}
                </Row>
              </>
            )}

            {hideContent?.bankSolvency && (
              <>
                <Row>
                  <Col span={7}>
                    <Form.Item
                      className="m-0"
                      label="Issued On"
                      name={[index, "issuedDate"]}
                    >
                      <DatePicker style={{ width: "100%" }} />
                    </Form.Item>
                  </Col>
                </Row>
              </>
            )}

            {masterData?.some((d: any) => d.docType === 19) && (
              <>
                <Row gutter={10}>
                  <Col style={{ padding: "14px 7px" }}>
                    <Checkbox onChange={handleCheckboxChange("supplies")} />
                  </Col>
                  <Col style={{ padding: "14px 7px" }}>
                    Previous Supplies Detail
                  </Col>
                  {hideContent?.supplies && (
                    <>
                      <Col
                        style={{
                          marginLeft: "auto",
                          textAlign: "end",
                          display: "flex",
                          justifyContent: "end",
                        }}
                      >
                        <Form.Item
                          className="m-0"
                          name={[index, "suppliesDocument"]}
                          valuePropName="fileList"
                          getValueFromEvent={(e) => {
                            return e.fileList;
                          }}
                        >
                          <Upload
                            accept=".doc,.docx,.pdf,.jpg,.jpeg,.png,.txt,.csv,.gif,.xls,.xlsx"
                            beforeUpload={(file: any) => {
                              if (file.size > 5242880) {
                                return Upload.LIST_IGNORE;
                              }

                              const reader = new FileReader();
                              reader.readAsDataURL(file);
                              reader.onload = () => {
                                file.base64 = reader.result;
                                const formFieldValue =
                                  form
                                    .useFormInstance()
                                    ?.getFieldValue([
                                      index,
                                      "equipmentListDocument",
                                    ]) || [];
                                form
                                  .useFormInstance()
                                  ?.setFieldsValue([
                                    index,
                                    "equipmentListDocument",
                                    [...formFieldValue, file],
                                  ]);
                              };
                              return false;
                            }}
                          >
                            <Button
                              style={{ marginTop: "10px", color: "#058BC9" }}
                              icon={<UploadOutlined />}
                            >
                              Upload
                            </Button>
                          </Upload>
                        </Form.Item>
                      </Col>
                    </>
                  )}
                </Row>
              </>
            )}

            {hideContent?.supplies && (
              <>
                <Row>
                  <Col span={7}>
                    <Form.Item
                      className="m-0"
                      label="Date"
                      name={[index, "suppliesDate"]}
                    >
                      <DatePicker style={{ width: "100%" }} />
                    </Form.Item>
                  </Col>
                  <Col span={7}>
                    <Form.Item
                      className="m-0"
                      label="PO Number"
                      name={[index, "PONumber"]}
                    >
                      <Input style={{ width: "100%" }} />
                    </Form.Item>
                  </Col>
                </Row>
              </>
            )}

            {masterData?.some((d: any) => d?.docType === 20) && (
              <>
                <Row gutter={10}>
                  <Col style={{ padding: "14px 7px" }}>
                    <Checkbox
                      onChange={handleCheckboxChange("listOfDirector")}
                    />
                  </Col>
                  <Col style={{ padding: "14px 7px" }}>
                    List of Directors/Partners
                  </Col>
                </Row>

                {hideContent?.listOfDirector && (
                  <>
                    <Row>
                      <Col span={7}>
                        <Form.Item
                          className="m-0"
                          label="Name"
                          name={[index, "partnersNumber"]}
                        >
                          <Input style={{ width: "100%" }} />
                        </Form.Item>
                      </Col>
                    </Row>
                  </>
                )}
              </>
            )}

            {masterData?.some((d: any) => d.docType === 21) && (
              <>
                <Row gutter={10}>
                  <Col style={{ padding: "14px 7px" }}>
                    <Checkbox
                      onChange={handleCheckboxChange("productDetail")}
                    />
                  </Col>
                  <Col style={{ padding: "14px 7px" }}>Product Detail</Col>
                </Row>

                {hideContent?.productDetail && (
                  <>
                    <Row>
                      <Col span={7}>
                        <Form.Item
                          className="m-0"
                          label="Name"
                          name={[index, "productName"]}
                        >
                          <Input style={{ width: "100%" }} />
                        </Form.Item>
                      </Col>
                    </Row>
                  </>
                )}
              </>
            )}

            {masterData?.some((d: any) => d.docType === 14) && (
              <>
                <Row gutter={10}>
                  <Col style={{ padding: "14px 7px" }}>
                    <Checkbox onChange={handleCheckboxChange("bankDetails")} />
                  </Col>
                  <Col style={{ padding: "14px 7px" }}>
                    Bank Details with Cancel Cheque
                  </Col>
                  {hideContent?.bankDetails && (
                    <>
                      <Col
                        style={{
                          marginLeft: "auto",
                          textAlign: "end",
                          display: "flex",
                          justifyContent: "end",
                        }}
                      >
                        <Form.Item
                          className="m-0"
                          name={[index, "bankDocument"]}
                          valuePropName="fileList"
                          getValueFromEvent={(e) => {
                            return e.fileList;
                          }}
                        >
                          <Upload
                            accept=".doc,.docx,.pdf,.jpg,.jpeg,.png,.txt,.csv,.gif,.xls,.xlsx"
                            beforeUpload={(file: any) => {
                              if (file.size > 5242880) {
                                return Upload.LIST_IGNORE;
                              }

                              const reader = new FileReader();
                              reader.readAsDataURL(file);
                              reader.onload = () => {
                                file.base64 = reader.result;
                                const formFieldValue =
                                  form
                                    .useFormInstance()
                                    ?.getFieldValue([
                                      index,
                                      "equipmentListDocument",
                                    ]) || [];
                                form
                                  .useFormInstance()
                                  ?.setFieldsValue([
                                    index,
                                    "equipmentListDocument",
                                    [...formFieldValue, file],
                                  ]);
                              };
                              return false;
                            }}
                          >
                            <Button
                              style={{ marginTop: "10px", color: "#058BC9" }}
                              icon={<UploadOutlined />}
                            >
                              Upload
                            </Button>
                          </Upload>
                        </Form.Item>
                      </Col>
                    </>
                  )}
                </Row>
              </>
            )}

            {hideContent?.bankDetails && (
              <>
                <Row justify={"space-between"}>
                  <Col span={7}>
                    <Form.Item
                      className="m-0"
                      label="Bank Name"
                      name={[index, "bankName"]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col span={7}>
                    <Form.Item
                      className="m-0"
                      label="Branch"
                      name={[index, "branch"]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col span={7}>
                    <Form.Item
                      className="m-0"
                      label="Account No"
                      name={[index, "accountNo"]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col span={7}>
                    <Form.Item
                      className="m-0"
                      label="Account Holder Name"
                      name={[index, "accountHolderName"]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col span={7}>
                    <Form.Item
                      className="m-0"
                      label="Account Type"
                      name={[index, "accountType"]}
                    >
                      <Select
                        options={[
                          {
                            label: "All",
                            value: BankAccountType_New.All,
                          },
                          {
                            label: "Saving Account",
                            value: BankAccountType_New.SavingAccount,
                          },
                          {
                            label: "Current Account",
                            value: BankAccountType_New.CurrentAccount,
                          },
                          {
                            label: "Cash Credit Account",
                            value: BankAccountType_New.CashCreditAccount,
                          },
                          {
                            label: "Over Draft Account",
                            value: BankAccountType_New.OverdraftAccount,
                          },
                          {
                            label: "Credit Card",
                            value: BankAccountType_New.CreditCard,
                          },
                        ]}
                      />
                    </Form.Item>
                  </Col>

                  <Col span={7}>
                    <Form.Item
                      className="m-0"
                      label="IFSC"
                      name={[index, "IFSCNumber"]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                </Row>
              </>
            )}

            {masterData?.some((d: any) => d.docType === 17) && (
              <>
                <Row gutter={10}>
                  <Col style={{ padding: "14px 7px" }}>
                    <Form.Item className="m-0">
                      <Checkbox
                        onChange={handleCheckboxChange("clientageDetail")}
                      />
                    </Form.Item>
                  </Col>
                  <Col style={{ padding: "18px 0px 7px 7px" }}>
                    Clientage Detail
                  </Col>
                  {/* {hideContent?.clientageDetail && (
              <>
              
              </>
            )} */}
                </Row>
                {hideContent?.clientageDetail && (
                  <>
                    <Form.List name="clientDetails">
                      {(fields, { add, remove }) => (
                        <>
                          <Row justify="end">
                            <Col>
                              <Button
                                style={{ marginTop: "10px", color: "#058BC9" }}
                                icon={<PlusOutlined />}
                                onClick={() => add()}
                              >
                                Add More
                              </Button>
                            </Col>
                          </Row>

                          {fields?.map(({ key, name, ...restField }) => (
                            <Row
                              justify={"space-between"}
                              key={key}
                              gutter={[16, 16]}
                            >
                              <Col span={7}>
                                <Form.Item
                                  className="m-0"
                                  {...restField}
                                  label="Client Name"
                                  name={[name, "name"]}
                                  rules={[
                                    {
                                      required: true,
                                      message: "Client name is required",
                                    },
                                  ]}
                                >
                                  <Input />
                                </Form.Item>
                              </Col>

                              <Col span={7}>
                                <Form.Item
                                  className="m-0"
                                  {...restField}
                                  label="Client Since"
                                  name={[name, "since"]}
                                  rules={[
                                    {
                                      required: true,
                                      message: "Client since is required",
                                    },
                                  ]}
                                >
                                  <Input />
                                </Form.Item>
                              </Col>

                              <Col style={{ marginTop: "27px" }}>
                                <Button
                                  size="small"
                                  onClick={() => remove(name)}
                                  disabled={fields?.length === 1}
                                  icon={
                                    <DeleteOutlined style={{ color: "red" }} />
                                  }
                                />
                              </Col>
                            </Row>
                          ))}
                        </>
                      )}
                    </Form.List>
                  </>
                )}
              </>
            )}
          </Spin>
        </Card>
      </div>
    </>
  );
};
const LastStep = () => {
  return (
    <>
      <div style={{ maxWidth: "900px", margin: "0 auto" }}>
        <Result
          status="success"
          title="Account Registration Successful!"
          subTitle="Our team will review your details within the next 24–48 hours to ensure everything is in order. 
          You’ll receive a confirmation email once the review is complete, at which point you’ll have full access to all features."
        />
      </div>
    </>
  );
};
export { FifthStepReg, LastStep };
